/* Admin toggle for the sold-cars marquee. */
import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function SoldMarqueeToggle() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try { const r = await api.get("/admin/sold-announcements"); setData(r.data); }
    catch (e) { /* silent */ }
  };
  useEffect(() => { load(); }, []);

  const toggle = async () => {
    if (!data) return;
    setBusy(true);
    try {
      await api.post("/admin/sold-announcements/toggle", { enabled: !data.enabled });
      await load();
    } finally { setBusy(false); }
  };

  if (!data) return null;

  return (
    <div className="border border-gray-200 bg-white rounded-lg p-3 flex items-center gap-3" data-testid="sold-marquee-toggle">
      <div className="flex-1">
        <div className="font-semibold text-sm text-[#061426]">Public 'just sold' marquee</div>
        <div className="text-xs text-gray-500">
          Scrolls across every public page · 9:01 AM → 9:00 PM ET (auto-adjusts for DST) · shows today's sold deals.
        </div>
        <div className="text-xs mt-1">
          <span className={`px-2 py-0.5 rounded font-bold ${data.enabled ? "bg-emerald-100 text-emerald-700" : "bg-gray-200 text-gray-700"}`}>
            {data.enabled ? "ENABLED" : "DISABLED"}
          </span>
          {data.enabled && (
            <span className={`ml-2 px-2 py-0.5 rounded ${data.currently_open ? "bg-blue-100 text-blue-700" : "bg-gray-100 text-gray-600"}`}>
              {data.currently_open ? "Showing right now" : "Off-hours · will show 9:01am ET"}
            </span>
          )}
        </div>
      </div>
      <button onClick={toggle} disabled={busy}
        className={`px-4 py-2 rounded-lg text-sm font-semibold ${data.enabled ? "bg-gray-200 text-gray-800 hover:bg-gray-300" : "bg-[#006DFF] text-white hover:bg-blue-700"}`}
        data-testid="sold-marquee-toggle-btn">
        {busy ? "…" : data.enabled ? "Turn OFF" : "Turn ON"}
      </button>
    </div>
  );
}
